var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginTrim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 265,
    viewBox: "0 0 390 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1250_8480",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 390,
    height: 265
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 265,
    width: 390,
    height: 265,
    transform: "rotate(-180 390 265)",
    fill: "#FFFEF9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1250_8480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609 265L609 46.4157L609 0.0957336L609 6.10352e-05L608.766 0.0957336C607.399 0.10672 600.221 0.310668 593.328 3.2991C586.097 6.435 581.399 11.2353 581.399 11.2353L581.454 11.3075L581.396 11.331L581.393 11.3279C566.035 -3.52332 541.551 -3.52332 526.196 11.3279L526.192 11.3279C510.837 -3.52332 486.351 -3.52333 470.995 11.3279L470.994 11.3279C455.638 -3.52333 431.152 -3.52333 415.795 11.3279L415.792 11.3279C400.436 -3.52492 375.95 -3.52492 360.595 11.3279L360.591 11.3279C345.236 -3.52334 320.75 -3.52334 305.393 11.3279L305.391 11.3279C290.035 -3.52493 265.55 -3.52493 250.192 11.3278L250.191 11.3278C234.833 -3.52335 210.349 -3.52335 194.992 11.3278C179.635 -3.52494 155.151 -3.52494 139.793 11.3278C124.438 -3.52494 99.952 -3.52495 84.5946 11.3278C69.2388 -3.52495 44.7533 -3.52495 29.3959 11.3278C14.0401 -3.52495 -10.4454 -3.52496 -25.8028 11.3278C-41.1603 -3.52496 -65.6441 -3.52496 -81.0016 11.3278C-96.359 -3.52496 -120.844 -3.52497 -136.2 11.3278C-151.558 -3.52497 -176.042 -3.52497 -191.399 11.3278C-191.399 11.3278 -196.095 6.52746 -203.328 3.39156C-210.986 0.070546 -219 0.188221 -219 0.188221L-219 265L609 265Z",
    fill: "#FDF1DB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginTrim);
export default __webpack_public_path__ + "static/media/login_trim.e20cdfdda007d4af7a9f398bac30bb91.svg";
export { ForwardRef as ReactComponent };